import MainLayout from "@/components/layouts";
import { ContactAppointmentsTable } from "./appointments-table";

export default function ContactAppointmentsPage() {
  return (
    <MainLayout breadcrumb={[{ name: "Appointments", href: "#" }]}>
      <ContactAppointmentsTable title="Appointments" description="Appointments at the properties you are a contact at" />
    </MainLayout>
  );
}
